import React, { useRef, useImperativeHandle, forwardRef } from 'react';

import { DataChange } from 'devextreme/common/grids';

import FieldGrid, { FieldGridHandle } from './FieldGrid';

import ReportingFieldMappingDto from '../../classes/dtos/pathreportingmodule/ReportingFieldMappingDto';

import TransformationCapabilitiesDto from '../../classes/dtos/transformationmodule/TransformationCapabilitiesDto';
import PathReportingMappingCapabilitiesDto from '../../classes/dtos/pathreportingmodule/PathReportingMappingCapabilitiesDto';


interface ReportingExposedFieldsProps {
    MappingChanges: DataChange[] | undefined;
    SetMappingChanges(changes: DataChange[], origin: ReportingFieldMappingDto[]): void;

    Capabilities: PathReportingMappingCapabilitiesDto[];
    TransformationsCapabilities: TransformationCapabilitiesDto[];
    Mapping: ReportingFieldMappingDto[];
    IsSimpleFilterMode: boolean;
    FiltersEnabled: boolean;
    TableReferenceId: number;

    AdvancedFilterMode: boolean;
    SetAdvancedFilterMode(value: boolean): void;
    AdvancedFilterModeLocked: boolean;

    SelectionIds: number[];
    SetSelectionIds(ids: number[]): void;
}

export interface ReportingExposedFieldsHandle {
    Save: () => void;
}

const ReportingExposedFields = forwardRef<ReportingExposedFieldsHandle, ReportingExposedFieldsProps>(({ MappingChanges, SetMappingChanges, Capabilities, TransformationsCapabilities, Mapping, IsSimpleFilterMode, FiltersEnabled, TableReferenceId, AdvancedFilterMode, SetAdvancedFilterMode, AdvancedFilterModeLocked, SelectionIds, SetSelectionIds }, ref) => {

    useImperativeHandle(ref, () => ({
        Save() {
            if (fieldGridRef.current) {
                fieldGridRef.current.Save();
            }
        }
    }));

    const fieldGridRef = useRef<FieldGridHandle>(null);

    return (
        <div style={{ width: '100%', height: '100%', position: 'relative', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', display: 'inline-flex' }}>
            <div style={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', display: 'inline-flex' }}>
                <FieldGrid
                    ref={fieldGridRef}
                    MappingChanges={MappingChanges}
                    SetMappingChanges={SetMappingChanges}

                    Capabilities={Capabilities}
                    TransformationsCapabilities={TransformationsCapabilities}
                    Mapping={Mapping}
                    IsSimpleFilterMode={IsSimpleFilterMode}
                    FiltersEnabled={FiltersEnabled}
                    TableReferenceId={TableReferenceId}
                    AdvancedFilterMode={AdvancedFilterMode}
                    SetAdvancedFilterMode={SetAdvancedFilterMode}
                    AdvancedFilterModeLocked={AdvancedFilterModeLocked}
                    SelectionIds={SelectionIds}
                    SetSelectionIds={SetSelectionIds} />
            </div>
        </div>
    );
});

export default ReportingExposedFields;